import { useContext, useEffect, useState } from "react";
import { formatDateToDDMMAAAA } from "../../../../../functions/kit-mdtw/dates";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ActionMassive from "./ActionMassive";
import ModalGenerico from "../../../../ui/kit-modal/ModalGenerico";
import FooterTable from "../../../../ui/kit-mdtw/table/FooterTable";
import Tooltip from "../../../../ui/kit-mdtw/tooltip/Tooltip";
import OperacionContratacionContext from "../../../../../context/Operaciones/OperacionContratacionContext";
import {
  IActivityStopRequest,
  IBajasCalculadas,
  Params,
} from "../../../../../interfaces/IOperacionesContratacion";
import IconSolicitudNotificada from "../../../../ui/kit-svg/icon-bajas-confirmadas/IconSolicitudNotificada";
import IconDetenerSolicitud from "../../../../ui/kit-svg/icon-bajas-confirmadas/IconDetenerSolicitud";
import IconAnularDocumento from "../../../../ui/kit-svg/icon-bajas-confirmadas/IconAnularDocumento";
import AnularDocumento from "../../Modals/AnularDocumento";
import DetenerSolicitud from "../../Modals/DetenerSolicitud";
import IconLoading from "../../../../ui/kit-svg/IconLoading";
import TableSkeleton from "../../../../ui/kit-mdtw/table/TableSkeleton";
import ModalNoProcesado from "../../../../ui/kit-modal/noProcesado/ModalNoProcesado";
import { useParams } from "react-router-dom";

const TablaCalculadas = () => {
  const {
    token,
    listaNoProcesados,
    listaBajasCalculadas,
    getBajasCalculadas,
    postDetenerSolicitud,
    postAnularDocumento,
  } = useContext(OperacionContratacionContext);
  const { idCliente } = useParams<Params>();
  const [isLoadingTable, setIsLoadingTable] = useState<boolean | undefined>(
    undefined
  );
  const [isErrorTable, setIsErrorTable] = useState<boolean | undefined>(
    undefined
  );
  const [listadoSeleccionado, setListadoSeleccionado] = useState<string[]>([]);
  const [isOpenModalNoProcesado, setIsOpenModalNoProcesado] =
    useState<boolean>(false);
  const [isOpenModalAnularDocumento, setIsOpenModalAnularDocumento] =
    useState<boolean>(false);
  const [isOpenModalDetenerSolicitud, setIsOpenModalDetenerSolicitud] =
    useState<boolean>(false);
  const [currentCandidates, setCurrentCandidates] = useState<string[]>([]);
  const [gridListaBajasCalculadas, setGridListaBajasCalculadas] = useState<
    IBajasCalculadas[]
  >([]);
  const [range, setRange] = useState<any>({
    initRange: 1,
    endRange: 10,
  });
  const [lengthFilters, setLengthFilters] = useState<number>(0);
  const [changePage, setChangePage] = useState<boolean>(false);
  const [localStorageFilter, setLocalStorageFilter] = useState<string>(
    "filtroBajasCalculadas"
  );
  const [candidates, setCandidates] = useState<any>([]);
  const [buttonDetener, setButtonDetener] = useState<boolean>(false);
  const [isLoadingPost, setIsLoadingPost] = useState<boolean>(false);
  const [isErrorPost, setIsErrorPost] = useState<boolean>(false);
  const [selectCurrent, setSelectCurrent] = useState<any>([]);
  const [reasonAll, setReasonAll] = useState<any>({
    motivoAll: { value: "" },
  });
  const [formFilter, setFormFilter] = useState<any>({
    estado: [],
    nombre: [],
    ficha: [],
    codCargo: [],
    areaNegocio: [],
    fechaCalculo: [],
    division: [],
    cliente:[idCliente]
  });

  useEffect(() => {
    if (token) {
      if (localStorage.getItem(localStorageFilter)) {
        const copyStorage: any = localStorage.getItem(localStorageFilter);
        JSON.parse(copyStorage);
        getBajasCalculadas({
          token,
          filtros: JSON.parse(copyStorage),
          setIsErrorTable,
          setIsLoadingTable,
        });
      } else {
        getBajasCalculadas({
          token,
          filtros: formFilter,
          setIsErrorTable,
          setIsLoadingTable,
        });
      }
    }
  }, [token, localStorage.getItem(localStorageFilter)]);

  useEffect(() => {
    if (selectCurrent) {
      const hayTextoEnValue = Object.values(selectCurrent).some(
        (item: any) => item.value && item.value.trim() !== ""
      );
      setButtonDetener(hayTextoEnValue);
    }
  }, [selectCurrent]);

  useEffect(() => {
    if (listaBajasCalculadas) {
      const arrayList = listaBajasCalculadas.map(
        (item: IBajasCalculadas) => item.divisionId + "-" + item.ficha
      );
      setCurrentCandidates(arrayList);
    }
  }, [listaBajasCalculadas]);

  useEffect(() => {
    if (listaBajasCalculadas) {
      let arrayGridFilter = [...listaBajasCalculadas];

      setLengthFilters(arrayGridFilter.length);
      if (range) {
        const { initRange, endRange } = range;
        arrayGridFilter = arrayGridFilter.slice(initRange, endRange);
      }
      setGridListaBajasCalculadas(arrayGridFilter);
    }
  }, [listaBajasCalculadas, range]);

  const handleClickAddOrRemoveChoise = (prompts: any): void => {
    const { divisionId, ficha } = prompts;
    const arrayList: string[] = [...listadoSeleccionado];

    if (!arrayList.includes(divisionId + "-" + ficha)) {
      arrayList.push(divisionId + "-" + ficha);
    } else {
      const position: number = arrayList.findIndex(
        (item: string) => item === divisionId + "-" + ficha
      );
      arrayList.splice(position, 1);
    }
    setListadoSeleccionado(arrayList);
  };

  const handleClickAddAll = (): void => {
    const arrayListado: string[] = [...listadoSeleccionado];

    if (listadoSeleccionado.length < currentCandidates.length) {
      currentCandidates
        .filter((item: any) => !listadoSeleccionado.includes(item))
        .map((item: any) => arrayListado.push(item));
    } else {
      arrayListado.splice(0, currentCandidates.length);
    }
    setListadoSeleccionado(arrayListado);
  };

  const handleClickAnularDocumento = (values: any): void => {
    const { divisionId, ficha } = values;
    if (ficha && divisionId) {
      setCandidates([divisionId + "-" + ficha]);
      setIsOpenModalAnularDocumento(true);
    }
  };

  const handleClickDetenerSolicitud = (values: any): void => {
    const { divisionId, ficha } = values;
    setCandidates([divisionId + "-" + ficha]);
    setIsOpenModalDetenerSolicitud(true);
  };

  const handleClickDetener = async (values: IActivityStopRequest) => {
    const { type } = values;
    if (token) {
      const arregloTransformado = Object.keys(selectCurrent).map(
        (clave: any) => {
          const numeroFicha = clave;
          const motivo = selectCurrent[clave].value;

          return {
            ficha: numeroFicha,
            motivo: motivo,
          };
        }
      );
      try {
        if (type == "detenerSolicitud") {
          await postDetenerSolicitud({
            token,
            contratos: arregloTransformado,
            setIsErrorPost,
            setIsLoadingPost,
            setIsOpenModalNoProcesado,
          });
        }

        if (type == "anularDocumento") {
          await postAnularDocumento({
            token,
            contratos: arregloTransformado,
            setIsErrorPost,
            setIsLoadingPost,
            setIsOpenModalNoProcesado,
          });
        }

        if (localStorage.getItem(localStorageFilter)) {
          const copyStorage: any = localStorage.getItem(localStorageFilter);
          JSON.parse(copyStorage);
          getBajasCalculadas({
            token,
            filtros: JSON.parse(copyStorage),
            setIsErrorTable,
            setIsLoadingTable,
          });
        } else {
          getBajasCalculadas({
            token,
            filtros: formFilter,
            setIsErrorTable,
            setIsLoadingTable,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <section className="content-seleccion-multiple action-in-line">
        <div className="content-multiple">
          <button onClick={handleClickAddAll} className="button-multiple">
            {listadoSeleccionado.length == currentCandidates.length &&
            listadoSeleccionado.length > 0 ? (
              <CheckBoxIcon />
            ) : (
              <CheckBoxOutlineBlankIcon />
            )}
          </button>
          <label className="title-multiple">
            Seleccionar Todo{" "}
            <span
              className={`selects-badge${listadoSeleccionado.length === 0 ? " inactive" : ""}`}
              style={{ transition: "background 0.3s ease, color 0.3s ease, font-weight 0.3s ease" }}
            >
              {listadoSeleccionado.length > 0
                ? `${listadoSeleccionado.length} ítem${listadoSeleccionado.length !== 1 ? "s" : ""} seleccionado${listadoSeleccionado.length !== 1 ? "s" : ""}`
                : "0 ítems seleccionados"}
            </span>
          </label>
        </div>
        <ActionMassive
          listadoSeleccionado={listadoSeleccionado}
          localStorageFilter={localStorageFilter}
          formFilter={formFilter}
          setFormFilter={setFormFilter}
          candidates={candidates}
          setCandidates={setCandidates}
        />
      </section>

      <section className="content-header-table">
        <label className="title-header-table">
          Bajas Confirmadas Procesadas
        </label>
      </section>

      {!isLoadingTable ? (
        <>
          {isErrorTable ? (
            <div className="container-is-error-table">
              Error al cargar los datos.
            </div>
          ) : (
            <>
              <main className="container-table-list">
                <table className="content-table">
                  <thead className="thead-table-registros">
                    <tr>
                      <th className="th-table-registros col-w-check"></th>
                      <th className="th-table-registros">Estado</th>
                      <th className="th-table-registros">Nombre</th>
                      <th className="th-table-registros">Ficha</th>
                      <th className="th-table-registros">
                        División <br></br>TW
                      </th>
                      <th className="th-table-registros">
                        Código <br></br>Cargo
                      </th>
                      <th className="th-table-registros">
                        Área de <br></br>Negocio
                      </th>
                      <th className="th-table-registros col-w-fecha">
                        Fecha Término <br></br>de Contrato
                      </th>
                      <th className="th-table-registros col-w-fecha">
                        Fecha <br></br>Cálculo
                      </th>
                      <th className="th-table-registros col-w-acciones">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-table-registros">
                    {gridListaBajasCalculadas &&
                      gridListaBajasCalculadas.map((item: IBajasCalculadas) => {
                        const {
                          ficha,
                          primerNombre,
                          primerApellido,
                          division,
                          codCargo,
                          divisionId,
                          areaNegocioCod,
                          estadoRegistro,
                          fechaTerminoContrato,
                          fechaCalculo,
                        } = item;
                        return (
                          <>
                            <tr
                              key={divisionId + "-" + ficha}
                              className={`tr-table-registros ${
                                listadoSeleccionado.includes(
                                  divisionId + "-" + ficha
                                ) && "checkeado"
                              }`}
                            >
                              <td className="td-table-registros col-w-check">
                                <button
                                  className="button-select"
                                  onClick={() =>
                                    handleClickAddOrRemoveChoise({
                                      divisionId,
                                      ficha,
                                    })
                                  }
                                >
                                  {listadoSeleccionado.includes(
                                    divisionId + "-" + ficha
                                  ) ? (
                                    <CheckBoxIcon />
                                  ) : (
                                    <CheckBoxOutlineBlankIcon />
                                  )}
                                </button>
                              </td>
                              <td className="td-table-registros">
                                <section className="content-state">
                                  {estadoRegistro == "CALCULADA" && (
                                    <>
                                      <IconSolicitudNotificada
                                        fill="#BE2A2A"
                                        className="content-icon"
                                      />
                                      <div className="content-state-text">
                                        <label className="message">
                                          Solicitud con doc. <br></br>
                                          calculado
                                        </label>
                                      </div>
                                    </>
                                  )}
                                  {estadoRegistro == "NOTIFICADA" && (
                                    <>
                                      <IconSolicitudNotificada
                                        fill="#BE2A2A"
                                        className="content-icon"
                                      />
                                      <div className="content-state-text">
                                        <label className="message">
                                          Solicitud notificada
                                        </label>
                                      </div>
                                    </>
                                  )}
                                </section>
                              </td>
                              <td className="td-table-registros">
                                {primerNombre} {primerApellido}
                              </td>
                              <td className="td-table-registros">{ficha}</td>
                              <td className="td-table-registros">{division}</td>
                              <td className="td-table-registros">{codCargo}</td>
                              <td className="td-table-registros">
                                {areaNegocioCod}
                              </td>
                              <td className="td-table-registros col-w-fecha">
                                {formatDateToDDMMAAAA({
                                  date: fechaTerminoContrato,
                                  format: "/",
                                })}
                              </td>
                              <td className="td-table-registros col-w-fecha">
                                {formatDateToDDMMAAAA({
                                  date: fechaCalculo,
                                  format: "/",
                                })}
                              </td>
                              <td className="td-table-registros col-w-acciones">
                                <section className="content-icon-table">
                                  <Tooltip text="Detener Solicitud">
                                    <button
                                      className={`button-content`}
                                      disabled={estadoRegistro == "CALCULADA"}
                                      onClick={() =>
                                        handleClickDetenerSolicitud({
                                          divisionId,
                                          ficha,
                                        })
                                      }
                                    >
                                      <IconDetenerSolicitud
                                        fill="#BE2A2A"
                                        disabled={estadoRegistro == "CALCULADA"}
                                      />
                                    </button>
                                  </Tooltip>
                                  <Tooltip text="Anular Documento">
                                    <button
                                      className={`button-content`}
                                      disabled={estadoRegistro == "NOTIFICADA"}
                                      onClick={() =>
                                        handleClickAnularDocumento({
                                          divisionId,
                                          ficha,
                                        })
                                      }
                                    >
                                      <IconAnularDocumento
                                        fill="#BE2A2A"
                                        disabled={
                                          estadoRegistro == "NOTIFICADA"
                                        }
                                      />
                                    </button>
                                  </Tooltip>
                                </section>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                  </tbody>
                </table>
              </main>
              <FooterTable
                length={lengthFilters}
                setRange={setRange}
                pageCurrent={changePage ? 1 : undefined}
              />
            </>
          )}
        </>
      ) : (
        <TableSkeleton cols={10} />
      )}

      {isOpenModalAnularDocumento && (
        <ModalGenerico
          title="Anular Baja y Finiquito"
          width="w-80"
          buttonBackText="Cancelar"
          buttonGoText="Anular Finiquito"
          buttonGoStyle="delete"
          buttonGoDisable={buttonDetener}
          onChangeBack={() => {
            setIsOpenModalAnularDocumento(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => {
            handleClickDetener({ type: "anularDocumento" });
            setIsOpenModalAnularDocumento(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <AnularDocumento
            token={token}
            list={candidates}
            listData={listaBajasCalculadas}
            reasonAll={reasonAll}
            setReasonAll={setReasonAll}
            selectCurrent={selectCurrent}
            setSelectCurrent={setSelectCurrent}
          />
        </ModalGenerico>
      )}

      {isOpenModalDetenerSolicitud && (
        <ModalGenerico
          title="Detener solicitud de Baja Confirmada"
          width="w-80"
          buttonBackText="Cancelar"
          buttonGoText="Detener Baja"
          buttonGoStyle="delete"
          buttonGoDisable={buttonDetener}
          onChangeBack={() => {
            setIsOpenModalDetenerSolicitud(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => {
            handleClickDetener({ type: "detenerSolicitud" });
            setIsOpenModalDetenerSolicitud(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <DetenerSolicitud
            token={token}
            list={candidates}
            listData={listaBajasCalculadas}
            reasonAll={reasonAll}
            setReasonAll={setReasonAll}
            selectCurrent={selectCurrent}
            setSelectCurrent={setSelectCurrent}
          />
        </ModalGenerico>
      )}

      {isOpenModalNoProcesado && (
        <ModalGenerico
          title="Solicitud NO procesada"
          iconTitle="danger"
          subtitle="La solicitud para los siguientes trabajadores no pudo ser procesada:"
          width="w-80"
          buttonBackText="Cerrar"
          onChangeBack={() => {
            setIsOpenModalNoProcesado(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => {
            setIsOpenModalNoProcesado(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalNoProcesado
            list={listaNoProcesados}
          />
        </ModalGenerico>
      )}
    </>
  );
};

export default TablaCalculadas;
